import { render, staticRenderFns } from "./SickLeaveTable.vue?vue&type=template&id=79291632"
import script from "./SickLeaveTable.vue?vue&type=script&lang=js"
export * from "./SickLeaveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports